@for (participant of participantsList; track participant; let index = $index) {
  <div
    class="celo-cursor-pointer usercard"
    data-testid="mention-result"
    [attr.data-mention-user-id]="participant.userId"
    (mousedown)="handleMouseDown($event)"
    (click)="handleClick($event, participant)"
    [ngClass]="{ 'celo-hovered': index === selectedIndex }"
  >
    <div [id]="'selectionAnchor' + index" class="selection-anchor"></div>
    <app-celo-user-card
      [userId]="participant.userId"
      [title]="participant.title"
      [firstName]="participant.firstName"
      [lastName]="participant.lastName"
      [profilePic]="participant.profilePicture"
      [showBadge]="false"
      [contact]="participant"
      [profileId]="userId"
      [replaceMyName]="
        participant.firstName + ' ' + participant.lastName + ' (You)'
      "
    >
    </app-celo-user-card>
  </div>
}
